import React from "react";
import { useSceneStore } from "../../store/sceneStore";
import { useSettingsStore } from "../../store/settingsStore";

export function PerformancePanel() {
  const fps = useSceneStore((s) => s.fps);
  const performanceMode = useSettingsStore((s) => s.performanceMode);

  return (
    <aside className="tls-astro-panel tls-astro-panel-secondary">
      <h3>Desempenho</h3>
      <ul className="tls-astro-list">
        <li>FPS: {fps}</li>
        <li>Modo: {performanceMode}</li>
        <li>Depth buffer: logarítmico</li>
      </ul>
    </aside>
  );
}
